export default {
  FlexRow: {
    display: 'flex',
    flexWrap: 'wrap',

    '& > *': {
      flexShrink: 0,
    },
  },
} as const
